import React, { useMemo } from "react";
import T from "prop-types";
import cn from "classnames";

import { Field, Inputs } from "2g-form";

import useContentRenderer from "./useContentRenderer";

export function ContentRenderer({
  dateFrom,
  dateTo,
  index,
  isSelected,
  selection
}) {
  const { defaultMzo, defaultVzo, inputRef, showPlaceholder } =
    useContentRenderer({
      index,
      isSelected,
      selection
    });

  const paths = useMemo(
    () => ({
      datumOd: ["fixniNaroky", index, "datumOd"],
      datumDo: ["fixniNaroky", index, "datumDo"],
      mzo: ["fixniNaroky", index, "mzo"],
      vzo: ["fixniNaroky", index, "vzo"]
    }),
    [index]
  );

  return (
    <div
      key={[dateFrom.getTime(), dateTo.getTime()].join("-")}
      className={cn("b2b-SchedulerWeeksContent", {
        "is-placeholder": showPlaceholder
      })}
    >
      <Field
        component={Inputs.Input}
        path={paths.datumOd}
        type="number"
        defaultValue={dateFrom.getTime()}
        visible={false}
        destroyOnUnmount={false}
      />
      <Field
        component={Inputs.Input}
        path={paths.datumDo}
        type="number"
        defaultValue={dateTo.getTime()}
        visible={false}
        destroyOnUnmount={false}
      />
      <Field
        inputRef={inputRef}
        component={Inputs.Input}
        label="MZO"
        path={paths.mzo}
        defaultValue={defaultMzo}
        disabled={isSelected && index !== selection.from}
        destroyOnUnmount={false}
      />
      <Field
        component={Inputs.Input}
        label="VZO"
        path={paths.vzo}
        defaultValue={defaultVzo}
        disabled={isSelected && index !== selection.from}
        destroyOnUnmount={false}
      />
    </div>
  );
}

ContentRenderer.propTypes = {
  index: T.number.isRequired,
  dateFrom: T.instanceOf(Date).isRequired,
  dateTo: T.instanceOf(Date).isRequired,
  isSelected: T.bool.isRequired,
  selection: T.shape({
    from: T.number,
    to: T.number
  }).isRequired
};

export default React.memo(ContentRenderer);
